<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Consultar Templates
        </p>
        <p class="q-ml-sm text-h6 text-weight-bold text-brand-5 texto-titulo">
          - {{ usuario ? usuario.name : "Selecione um Usuário" }}
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md text-brand-5 text-weight-bold q-gutter-sm items-center"
    >
      <div class="col-md-2 col-xs-8">
        <div class="q-ml-sm text-brand-5 texto-inputs">Nome do Usuario</div>
        <q-select
          v-model="usuario"
          dense
          outlined
          class="select q-mt-sm q-mb-sm"
          label="Digite o nome para pesquisar"
          :options="usersList"
          option-label="name"
          option-value="id"
          use-input
          map-options
          @filter="filterFn"
        />
      </div>
    </div>
    {{ facesList }}
    <q-carousel
      v-model="slide"
      transition-prev="scale"
      transition-next="scale"
      swipeable
      animated
      control-color="white"
      navigation
      padding
      arrows
      height="300px"
      class="bg-primary text-white shadow-1 rounded-borders"
    >
      <q-carousel-slide
        v-for="(face, index) in facesList.Templates"
        :key="index"
        :img-src="'data:image/jpeg;base64,' + face.Data"
        name="primeiro"
        class="column no-wrap flex-center"
      >
        <img :src="'data:image/jpeg;base64,' + face.Data" alt="" />
      </q-carousel-slide>
    </q-carousel>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const time = ref();
    const usuario = ref(null);
    const facesList = ref([]);
    const slide = ref("primeiro");
    const usersList = ref([]);

    const getUsers = async (val) => {
      try {
        let response = await store.dispatch("facialStore/getUsers", {
          search: val,
        });
        usersList.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar usuarios",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getUsers);

    const getUserTemplate = async () => {
      try {
        const idFace = `${store.state.autenticacao.cliente[0]}${usuario.value.id}`;

        const response = await store.dispatch("facialStore/templatesFacial", {
          id: idFace,
        });

        facesList.value = response.data;

        quasar.notify({
          message: "Rosto cadastrado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Nenhuma template encontrada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch([() => usuario.value], () => {
      getUserTemplate();
    });

    return {
      usuario,
      usersList,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }
        usersList.value = [];
        time.value = setTimeout(() => {
          getUsers(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1500);

        setTimeout(() => {
          update();
        }, 1000);
      },
      getUserTemplate,
      facesList,
      slide,
    };
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

video {
  width: 50%;
  height: 100%;
}
</style>
